/**
 * @file automatically generated from MApp.Endpoints.BrowserClientContentController
 */

import { MetadataClient } from '../metadata-client';
import { ISaveBrowserActionSet, IBrowserActionSetListItem, IBrowserActionSet, IValidationResult, ISaveMapView, IMapView, IMapViewListItem } from '../models';

export class BrowserClientContentClient extends MetadataClient {

	public static saveBrowserActionSet(actionSet: ISaveBrowserActionSet, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/browseractionsets`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(actionSet),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static cloneBrowserActionSet(id: string, newName: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/studio/browseractionsets/clone/${encodeURIComponent(id)}?newName=${encodeURIComponent(newName)}`, {
				method: 'POST',
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static updateBrowserActionSet(id: string, actionSet: ISaveBrowserActionSet, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/browseractionsets/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(actionSet),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getBrowserActionSets(requestInit?: RequestInit) {
		return MetadataClient.ajax<IBrowserActionSetListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/browseractionsets`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getBrowserActionSet(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IBrowserActionSet>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/browseractionsets/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static deleteBrowserActionSet(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/browseractionsets/${encodeURIComponent(id)}`, {
				method: 'DELETE',
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static isValidBrowserActionSet(name: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IValidationResult>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/browseractionsets/isvalid?name=${encodeURIComponent(name)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static cloneMapView(id: string, newName: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/studio/mapviews/clone/${encodeURIComponent(id)}?newName=${encodeURIComponent(newName)}`, {
				method: 'POST',
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static saveMapView(mapView: ISaveMapView, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/studio/mapviews`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(mapView),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static updateMapView(id: string, mapView: ISaveMapView, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/studio/mapviews/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(mapView),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getMapView(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IMapView>(
			new Request(MetadataClient.endpointsUrl + `api/v2/studio/mapviews/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getMapViews(requestInit?: RequestInit) {
		return MetadataClient.ajax<IMapViewListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v2/studio/mapviews`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static deleteMapView(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/studio/mapviews/${encodeURIComponent(id)}`, {
				method: 'DELETE',
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static isValidMapView(name: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IValidationResult>(
			new Request(MetadataClient.endpointsUrl + `api/v2/studio/mapviews/isvalid?name=${encodeURIComponent(name)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}
}
